module.exports = __webpack_public_path__ + "static/sp_checkout_2-6bf8c38f34e35616ce8961deaa7f5bb9.jpg";